import type {MethodDefWithParsedRestrictions} from '../../state/types/mthds.js';
import type {JoinedPeer} from '../../state/peers.js';
import {DomainKeys} from "../../state/types/state.js";
import {check} from '../../restrictions.js';

export function isClusterMethod(peer: JoinedPeer<DomainKeys.Agm>,
                                {parsedRestrictions}: Pick<MethodDefWithParsedRestrictions, 'parsedRestrictions'>): boolean {
    return check(parsedRestrictions, [{type: peer.source.type === 'local' ? 'local' : 'cluster'}, peer.identity], [{type: 'cluster'}, undefined]);
}
